// import './modules/slider';

//style
import '../style/main.scss';

//svg sprite
import '../static/img/svg/arrow-up-right.svg';
import '../static/img/svg/weight.svg';
import '../static/img/svg/energy.svg';
import '../static/img/svg/user.svg';
import '../static/img/svg/base.svg';
import '../static/img/svg/wrench.svg';
import '../static/img/svg/close.svg';
import '../static/img/svg/arrow-left.svg';
import '../static/img/svg/arrow-right.svg';

//libs



window.addEventListener('load', function () {
    const modalTrigger = document.querySelectorAll('.jsSectionMainTrigger');

    if (modalTrigger.length) {
        modalTrigger.forEach(trigger => {
            trigger.addEventListener('click', function () {
                document.querySelector('.jsSectionMainAdvantagesModal').classList.toggle('is-shown')
                document.querySelector('html').classList.toggle('is-fixed')
            })
        })
    }

    const sectionAdvantages = document.querySelectorAll('.jsSectionAdvantages');

    if (sectionAdvantages.length) {
        sectionAdvantages.forEach(section => {

            const buttons = section.querySelectorAll('.jsSectionAdvantagesButton')

            buttons.forEach((button, index) => {
                button.addEventListener('click', function () {
                    button.closest('.jsSectionAdvantages').querySelector('.jsSectionAdvantagesButton.is-active').classList.remove('is-active')
                    button.classList.add('is-active')

                    const items =  button.closest('.jsSectionAdvantages').querySelectorAll('.jsSectionAdvantagesItem');

                    items.forEach((item, itemIndex) => {
                        index === itemIndex ? item.classList.add('is-active') : item.classList.remove('is-active')
                    })
                })
            })
        })
    }

    const smoothLinks = document.querySelectorAll('.jsScrollLink');
    for (let smoothLink of smoothLinks) {
        smoothLink.addEventListener('click', function (e) {
            e.preventDefault();
            const id = smoothLink.getAttribute('href');

            document.querySelector(id).scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        });
    };

})
